export const skills = [
    "java" , "c" , "javascript" , "html" , "css" , "reactjs" , "nodejs"
];